// tour-anchors.ts — single source of truth for `data-tour-id` attributes.
//
// Why a constants file instead of inlined strings?
//   - The Tour component looks up DOM nodes via these IDs. A typo on
//     either side (anchor vs. tour STEPS) silently degrades to "anchor
//     missing → auto-skip". This file makes the contract explicit.
//   - Search-by-symbol (TS rename) catches all consumers, vs. grepping
//     loose strings.
//
// Naming convention: `<area>.<group>.<item>` (dot-separated). Tour code
// already CSS.escapes dots when querying, so this is safe.

export const TOUR_ANCHORS = {
  // Overview — seeded-candidates CTA banner (visible on first visit before
  // the user has scheduled/viewed/rejected any property).
  workspaceOverviewCandidatesCta: "workspace.overview.candidatesCta",
  // Workspace nav (sidebar/bottom-tab) — module buttons.
  workspaceNavShortlist: "workspace.nav.shortlist",
  workspaceNavCompare: "workspace.nav.compare",
  workspaceNavViewings: "workspace.nav.viewings",
  workspaceNavDecision: "workspace.nav.decision",
  // AI Advisor entry (Tour step 5 → cross-link to /chat).
  workspaceAdvisorEntry: "workspace.advisor.entry",
  // Prefs banner — Edit button (referenced by tour, e2e tests).
  workspacePrefsEdit: "workspace.prefsBar.edit",
  // Workspace switcher (top-of-sidebar dropdown).
  workspaceSwitcher: "workspace.switcher",
} as const;

export type TourAnchor = (typeof TOUR_ANCHORS)[keyof typeof TOUR_ANCHORS];
